const config: PageConfigurationType = {
    breadCrumbs: [{ label: 'home', path: 'home' }, 'registered_clients']
}

export default config
